import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid2";
import { DisplayGraphHeader } from "./displayGraphHeader";
import { engineInitialSelector } from "../../../constants/trendGraph/engine";
import { useDispatch } from "react-redux";
import { GRAPH_TYPE } from "../../../constants/trendGraph/trendGraphType";
import { setElectricDataDuration, setSepDataDuration } from "../../../model/slice/dataDurationSlice";
import { durationInitialState, sepDurationInitialState } from "../../../constants/duration";
import { DisplayChart } from "./displayChart";
import { Box, useTheme } from "@mui/material";
import { useStyles } from "../trendPageCommonStyles";
import PropTypes from "prop-types";

export const DisplayGraph = (props) => {
  const { 
    vesselId,
    isSepVessel,
    selectedGraph,
    selectedChart,
    selectedChartData,
    currentVessel,
    setIsCreateCustomCharts,
    trendCharts,
    isVesselOverview,
    setChartRef,
    customCharts,
    channels,
    isCustomChartsCreated,
    overviewTrendIdx,
  } = props;
  const theme = useTheme();
  const styles = useStyles(theme);
  const [selectedEngine, setSelectedEngine] = useState(() =>
    engineInitialSelector(currentVessel?.NoME)
  );
  const [graphData, setGraphData] = useState([]);
  const [dataFetchStatus, setDataFetchStatus] = useState({});
  const dispatch = useDispatch();
  const screenshotRef = useRef();
  const [graphConfig, setGraphConfig] = useState(null); // for new trend
  useEffect(() => {
    setSelectedEngine(engineInitialSelector(currentVessel?.NoME));
  }, [currentVessel]);

  useEffect(() => {
    switch (selectedGraph) {
      case GRAPH_TYPE.ELECTRIC:
        dispatch(setElectricDataDuration(durationInitialState())); break;
      case GRAPH_TYPE.SEP:
        dispatch(setSepDataDuration(sepDurationInitialState())); break;
    }
  }, [selectedGraph]);
  return (
    <Grid container sx={styles.chartContainer} spacing={1}>
      <Grid item size={{sm:12}} order={{sm: 2, md: 0}} ref={screenshotRef} sx={{ height: "calc(100dvh - 165px)", overflowY: "hidden" }}>
        <DisplayGraphHeader
          vesselId={vesselId}
          isSepVessel={isSepVessel}
          selectedGraph={selectedGraph}
          selectedChart={selectedChart}
          selectedChartData={selectedChartData}
          currentVessel={currentVessel}
          setIsCreateCustomCharts={setIsCreateCustomCharts}
          screenshotRef={screenshotRef}
          graphData={graphData}
          dataFetchStatus={dataFetchStatus}
          selectedEngine={selectedEngine}
          setSelectedEngine={setSelectedEngine}
          graphConfig={graphConfig}
        />
        <Box sx={{ maxHeight: "calc(100% - 30px)" }}>
          <DisplayChart
            selectedEngine={selectedEngine}
            graphData={graphData}
            setGraphData={setGraphData}
            setDataFetchStatus={setDataFetchStatus}
            vesselId={vesselId} 
            currentVessel={currentVessel}
            trendCharts={trendCharts}
            isVesselOverview={isVesselOverview}
            setChartRef={setChartRef}
            selectedGraph={selectedGraph}
            selectedChart={selectedChart}
            customCharts={customCharts}
            channels={channels}
            isCustomChartsCreated={isCustomChartsCreated}
            setSelectedEngine={setSelectedEngine}
            overviewTrendIdx={overviewTrendIdx}
            setGraphConfig={setGraphConfig}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

DisplayGraph.propTypes = {
  vesselId: PropTypes.string,
  isSepVessel: PropTypes.bool,
  selectedGraph: PropTypes.string,
  selectedChart: PropTypes.string,
  selectedChartData: PropTypes.array,
  currentVessel: PropTypes.object,
  setIsCreateCustomCharts: PropTypes.func,
  trendCharts: PropTypes.object,
  isVesselOverview: PropTypes.bool,
  setChartRef: PropTypes.func,
  customCharts: PropTypes. array,
  channels: PropTypes.array,
  isCustomChartsCreated: PropTypes.bool,
  overviewTrendIdx: PropTypes.number,
}